import React from 'react';
import PrimaryCarePhysicianInput from 'pages/Dashboard/components/PrimaryCarePhysicianInput';

type Part = 'provider' | 'contacts' | 'date' | 'dateContainer';
type Props = {
  classes?: Partial<Record<Part, string>>;
  required?: boolean;
  shouldStackContact?: boolean;
};

export default function PCPInputs({ classes, required, shouldStackContact }: Props) {
  return (
    <PrimaryCarePhysicianInput
      required={required}
      classes={classes}
      shouldStackContact={shouldStackContact}
    />
  );
}
